import React from 'react';

const TermsCondition = () => {
      return (
            <>
                  <span className="material-symbols-outlined">description</span>
            </>
      );
};

export default TermsCondition;
